import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, mergeProps as _mergeProps, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-57b0a121"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "cm-align-center info-tooltip",
  style: {"position":"absolute","right":"20px","top":"20px","color":"var(--el-color-primary)"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont cm-icon-info-fill fs-18",
  style: {"margin-right":"3px"}
}, null, -1))
const _hoisted_3 = { style: {"width":"400px","line-height":"1.4"} }
const _hoisted_4 = { class: "file-whitelist-page__stats" }
const _hoisted_5 = { class: "whitelist-sections" }
const _hoisted_6 = {
  class: "gap-x-10",
  style: {"display":"flex"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont cm-icon-info-fill fs-18",
  style: {"color":"var(--el-color-primary)"}
}, null, -1))
const _hoisted_8 = {
  class: /*#__PURE__*/_normalizeClass('tags-is-error el-card'),
  style: {"background-color":"var(--cm-color-card-bg)"}
}
const _hoisted_9 = { style: {"max-height":"200px"} }
const _hoisted_10 = {
  class: "cm-align-center gap-5",
  style: {"flex-wrap":"wrap","overflow-y":"auto","max-height":"180px","padding":"10px"}
}
const _hoisted_11 = { style: {"width":"100%"} }
const _hoisted_12 = { class: "cm-align-center gap-x-10" }
const _hoisted_13 = {
  key: 0,
  class: "uploaded-files-list"
}
const _hoisted_14 = { class: "file-name" }
const _hoisted_15 = {
  key: 0,
  class: "file-status"
}
const _hoisted_16 = {
  key: 1,
  class: "file-status"
}
const _hoisted_17 = {
  key: 2,
  class: "file-status"
}

import CmForm from '@/components/cmForm/index.vue'
import { reactive, ref, watch, onMounted, nextTick, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { FormActionType, FormSize, FormSizeType } from '@/components/cmForm/types'
import { WhiteListType, file_key, file_pattern, Status, handleCustomOperateType } from './types'
import { PolicySettingType, PolicyType } from '../_enum/policy-type'
import { getByTypeData, PolicyCommonService } from '../policy/policy-common.service'
import { ElMessageBox, ElMessage } from 'element-plus'
import WhitelistSection from './_components/whitelist-section.vue'
import StatisticsCards from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'
import { FileWhitelistService } from './service'
import { http, team, user } from '@/common/basis/root-injector'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const formType = FormActionType.Other
const { t, locale } = useI18n()
const injector = useReflectiveInjector([PolicyCommonService])
const groupPolicySettingsService = injector.get(PolicyCommonService)
const saveOrUpdateApi = groupPolicySettingsService.saveSettings.bind(groupPolicySettingsService)
const getByTypeApi = groupPolicySettingsService.getByType.bind(groupPolicySettingsService)

/** FileWhitelistService 依赖 Http，ReflectiveInjector 仅注册 Service 会报错；使用根 Http 单例构造 */
const fileWhitelistService = new FileWhitelistService(http)
const formSize: FormSizeType = FormSize.Small
const strategyObj = ref({} as getByTypeData)
const formRef = ref()
const listByType = ref({
  [file_key[WhiteListType.FILE_CHARACTERISTICS]]: [],
  [file_key[WhiteListType.FILE_PATH]]: [],
  [file_key[WhiteListType.FILE_FOLDER]]: [],
})
const visible = ref(false)
const md5Loading = ref(false)
const key = ref('')
const uploadFileRef = ref()
const fileInputRef = ref()
const interval = ref(null)
const uploadedFiles = ref<{ name: string; md5: string; status: 'uploading' | 'calculating' | 'success' | 'error' }[]>([])
const uploadProgress = ref({ current: 0, total: 0 })
const titleLabel = computed(() => ({
  [WhiteListType.FILE_CHARACTERISTICS]: t('safeProtectionModule.dialogFileFeature'),
  [WhiteListType.FILE_PATH]: t('safeProtectionModule.filePath'),
  [WhiteListType.FILE_FOLDER]: t('safeProtectionModule.fileDir'),
}))
const dialogTitle = computed(() => ({
  [WhiteListType.FILE_CHARACTERISTICS]: t('safeProtectionModule.dialogFileFeature'),
  [WhiteListType.FILE_PATH]: t('safeProtectionModule.dialogFilePath'),
  [WhiteListType.FILE_FOLDER]: t('safeProtectionModule.dialogFleDir'),
}))
const tableTitleLabel = computed(() => ({
  [WhiteListType.FILE_CHARACTERISTICS]: t('safeProtectionModule.fileFeatureTitle'),
  [WhiteListType.FILE_PATH]: t('safeProtectionModule.filePathTitle'),
  [WhiteListType.FILE_FOLDER]: t('safeProtectionModule.fileDirTitle'),
}))

const whitelistStatisticsItems = computed(() => {
  const labels = dialogTitle.value
  const list = listByType.value
  return [
    {
      label: labels[WhiteListType.FILE_CHARACTERISTICS],
      value: list[file_key[WhiteListType.FILE_CHARACTERISTICS]]?.length ?? 0,
      span: 8,
    },
    {
      label: labels[WhiteListType.FILE_PATH],
      value: list[file_key[WhiteListType.FILE_PATH]]?.length ?? 0,
      span: 8,
    },
    {
      label: labels[WhiteListType.FILE_FOLDER],
      value: list[file_key[WhiteListType.FILE_FOLDER]]?.length ?? 0,
      span: 8,
    },
  ]
})
const labelTipI18n = computed(() => ({
  [WhiteListType.FILE_CHARACTERISTICS]: [t('safeProtectionModule.fileWhitelistTipChar1'), t('safeProtectionModule.fileWhitelistTipChar2'), t('safeProtectionModule.fileWhitelistTipChar3')],
  [WhiteListType.FILE_PATH]: [t('safeProtectionModule.fileWhitelistTipPath1'), t('safeProtectionModule.fileWhitelistTipPath2')],
  [WhiteListType.FILE_FOLDER]: [t('safeProtectionModule.fileWhitelistTipDir1'), t('safeProtectionModule.fileWhitelistTipDir2')],
}))
const resetForm = { addFile: [], remark: '', calc_md5: '' }
const multiWords = ref('')
const activeName = ref(WhiteListType.FILE_CHARACTERISTICS)
const form = ref(resetForm)
const loading = ref(true)
const queryFormDisabled = ref(false)

// 每个类型独立的 queryForm
const queryForms = reactive({
  [WhiteListType.FILE_CHARACTERISTICS]: { file_name: '' },
  [WhiteListType.FILE_PATH]: { file_name: '' },
  [WhiteListType.FILE_FOLDER]: { file_name: '' },
})

// 每个类型独立的 ids
const idsByType = reactive({
  [WhiteListType.FILE_CHARACTERISTICS]: [],
  [WhiteListType.FILE_PATH]: [],
  [WhiteListType.FILE_FOLDER]: [],
})

const sectionRefSigns = ref<InstanceType<typeof WhitelistSection> | null>(null)
const sectionRefFiles = ref<InstanceType<typeof WhitelistSection> | null>(null)
const sectionRefDirs = ref<InstanceType<typeof WhitelistSection> | null>(null)

function clearAllWhitelistTableSelection() {
  sectionRefSigns.value?.clearTableSelection?.()
  sectionRefFiles.value?.clearTableSelection?.()
  sectionRefDirs.value?.clearTableSelection?.()
  idsByType[WhiteListType.FILE_CHARACTERISTICS] = []
  idsByType[WhiteListType.FILE_PATH] = []
  idsByType[WhiteListType.FILE_FOLDER] = []
}

const validateFileType = (rule, value, callback) => {
  if (value.some((item) => !file_pattern[activeName.value].test(item))) {
    callback(new Error(t('safeProtectionModule.formatError', { type: titleLabel.value[activeName.value] })))
  } else if (value && value.length > 1000) {
    callback(new Error(t('safeProtectionModule.whitelistMaxItems', { type: titleLabel.value[activeName.value] })))
  }
  callback()
}
const formColumns = computed(() => {
  void locale.value
  const type = activeName.value
  const typeLabel = tableTitleLabel.value[type]
  return {
    calc_md5: {
      label: t('safeProtectionModule.uploadFileLabel'),
      hidden: () => type !== WhiteListType.FILE_CHARACTERISTICS,
      slot: true,
      colOpt: { span: 24 }
    },
    addFile: {
      label: typeLabel,
      required: true,
      slot: true,
      colOpt: { span: 24 },
      rules: [{ custom: { validator: validateFileType } }],
      placeholder: t('safeProtectionModule.whitelistAddFilePlaceholder', { type: typeLabel }),
      inputType: 'textarea',
      inputOpt: { rows: 25, autosize: { minRows: 8, maxRows: 10 } },
    },
    remark: {
      label: t('safeProtectionModule.remark'), required: !IS_JP_ONLY_BUILD,
      colOpt: { span: 24 }
    }
  }
})

function openAddDialog(type: WhiteListType) {
  activeName.value = type
  visible.value = true
}

function handleChangeSelected(type: WhiteListType, idArray: any[]) {
  idsByType[type] = idArray
}

/** 白名单条数：每条一项 value，status 为 2 的不计 */
function countWhitelistEntries (list: unknown[]): number {
  if (!Array.isArray(list)) return 0
  return list.reduce<number>((n, raw) => {
    const r = raw as Record<string, unknown>
    if (r.status === 2) return n
    return n + 1
  }, 0)
}

function handleRemove(type: WhiteListType, row: any) {
  activeName.value = type
  idsByType[type] = [row.index]
  moveFile(type, false)
}

function handleBatchRemove(type: WhiteListType) {
  activeName.value = type
  moveFile(type, true)
}
const uploadError = () => {
  md5Loading.value = false
}
const clearFile = () => {
  uploadFileRef.value?.fileUploadRef?.clearFiles?.()
  uploadedFiles.value = []
  uploadProgress.value = { current: 0, total: 0 }
}
// 选择文件按钮点击
const handleSelectFiles = () => {
  fileInputRef.value?.click()
}
// 文件选择变化处理
const handleFilesChange = async (e: Event) => {
  const input = e.target as HTMLInputElement
  const files = Array.from(input.files || [])
  if (!files.length) return

  // 限制最多10个文件
  const filesToUpload = files.slice(0, 10)
  uploadProgress.value = { current: 0, total: filesToUpload.length }
  md5Loading.value = true

  // 遍历上传每个文件
  for (const file of filesToUpload) {
    await uploadSingleFile(file)
    uploadProgress.value.current++
  }

  md5Loading.value = false
  // 清空 input 以便可以重新选择相同文件
  input.value = ''
}
// 单个文件上传处理
const uploadSingleFile = async (file: File) => {
  const fileIndex = uploadedFiles.value.length
  uploadedFiles.value.push({
    name: file.name,
    md5: '',
    status: 'uploading'
  })

  try {
    const checkUploadApi = fileWhitelistService.checkUpload.bind(fileWhitelistService)
    const saveFileInfoApi = fileWhitelistService.saveFileInfo.bind(fileWhitelistService)
    const getFileTaskResultApi = fileWhitelistService.getFileTaskResult.bind(fileWhitelistService)

    // 1. 获取上传配置
    const result = await checkUploadApi({ file_name: file.name, file_size: file.size })

    // 2. 上传文件
    const formData = new FormData()
    // 添加 Values 中的字段
    if (result.Values) {
      Object.keys(result.Values).forEach(key => {
        formData.append(key, result.Values[key])
      })
    }
    formData.append('lang', String(locale.value))
    formData.append('team_id', String(team.getCurrentTeam().team_id))
    formData.append('uid', user.getUserInfo().uid)
    formData.append('token', user.getUserInfo().token)
    formData.append('file', file)

    const uploadHeaders = { ...result.Header }
    delete uploadHeaders['Content-Type'] // FormData 会自动设置

    await fetch(result.URL, {
      method: result.Method || 'POST',
      headers: uploadHeaders,
      body: formData
    })

    uploadedFiles.value[fileIndex].status = 'calculating'

    // 3. 保存文件信息并获取 MD5
    const saveFileInfo = await saveFileInfoApi({ key: result.key })

    // 4. 轮询获取 MD5 结果
    const md5Result = await pollForMd5(saveFileInfo.task_id, getFileTaskResultApi)

    if (md5Result) {
      uploadedFiles.value[fileIndex].md5 = md5Result
      uploadedFiles.value[fileIndex].status = 'success'
      // 添加到表单
      multiWords.value = md5Result
      handleAddTags('addFile')
    } else {
      uploadedFiles.value[fileIndex].status = 'error'
    }
  } catch (error) {
    console.error('上传失败:', error)
    uploadedFiles.value[fileIndex].status = 'error'
    ElMessage.error(t('safeProtectionModule.uploadFailNamed', { name: file.name })+','+t('safeProtectionModule.fileUploadLimit'))
  }
}
// 轮询获取 MD5
const pollForMd5 = (taskId: string, getFileTaskResultApi: any): Promise<string | null> => {
  return new Promise((resolve) => {
    const pollInterval = setInterval(async () => {
      try {
        const taskResult = await getFileTaskResultApi(taskId)
        if (![Status.PENDING, Status.RUNNING].includes(taskResult.status)) {
          clearInterval(pollInterval)
          if (taskResult.status === Status.COMPLETED && taskResult.file_sign) {
            resolve(taskResult.file_sign)
          } else {
            resolve(null)
          }
        }
      } catch {
        clearInterval(pollInterval)
        resolve(null)
      }
    }, 1000)

    // 超时处理（60秒）
    setTimeout(() => {
      clearInterval(pollInterval)
      resolve(null)
    }, 60000)
  })
}
// 移除已上传的文件
const removeUploadedFile = (index: number) => {
  const file = uploadedFiles.value[index]
  if (file.md5) {
    // 从 addFile 中移除对应的 MD5
    const md5Index = form.value.addFile.indexOf(file.md5)
    if (md5Index > -1) {
      form.value.addFile.splice(md5Index, 1)
    }
  }
  uploadedFiles.value.splice(index, 1)
}
const success = async (res, file) => {
  console.log('上传成功', res, file)
  form.value.calc_md5 = ''
  const saveFileInfoApi = fileWhitelistService.saveFileInfo.bind(fileWhitelistService)
  const getFileTaskResultApi = fileWhitelistService.getFileTaskResult.bind(fileWhitelistService)
  const saveFileInfo = await saveFileInfoApi({ key: key.value }).catch(() => { md5Loading.value = false })
  interval.value = setInterval(async () => {
    const taskResult = await getFileTaskResultApi(saveFileInfo.task_id)
    interval.value && ![Status.PENDING, Status.RUNNING].includes(taskResult.status) && clearInterval(interval.value);
    [Status.COMPLETED, Status.FAILED].includes(taskResult.status) && (md5Loading.value = false) && clearInterval(interval.value);
    [Status.FAILED].includes(taskResult.status) && ElMessage({
      type: 'error',
      message: t('safeProtectionModule.md5CalcFail'),
    });
    if (taskResult.file_sign) {
      multiWords.value = taskResult.file_sign
      handleAddTags('addFile')
      form.value.calc_md5 = taskResult.file_sign
    }
  }, 1000)
}
const beforeUpload = async (file, resolve: () => {}, reject: (msg: any) => {}, flag: boolean) => {
  if (!flag) return;
  const checkUploadApi = fileWhitelistService.checkUpload.bind(fileWhitelistService)
  const result = await checkUploadApi({ file_name: file.name, file_size: file.size }).catch(err => reject(new Error(err)))
  exact_url.value = result.URL
  data.value = result.Values
  method.value = result.Method
  headers.value = result.Header
  key.value = result.key
  resolve()
  clearInterval(interval.value);
  md5Loading.value = true
}
const moveFile = (type: WhiteListType, isMultiple: boolean) => {
  ElMessageBox.confirm(
    `<div class='cm-align-center' style='color: var(--cm-color-text-primary)'>
      <svg t="1788833020281" class="icon cm-ui-mr5" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16644" width="24" height="24"><path d="M783.132444 854.129778c0 32.483556-26.396444 58.936889-58.88 58.936889H299.747556c-32.426667 0-58.88-26.453333-58.88-58.936889V228.750222h542.264888v625.379556zM358.684444 122.993778a11.946667 11.946667 0 0 1 12.060445-12.060445h283.306667a11.946667 11.946667 0 0 1 12.060444 12.060445v35.498666H358.684444v-35.498666z m601.201778 35.498666h-223.573333v-35.498666A82.488889 82.488889 0 0 0 653.994667 40.675556H370.744889A82.488889 82.488889 0 0 0 288.426667 122.993778v35.498666H64.113778a35.441778 35.441778 0 1 0 0 70.997334h105.756444v624.64a129.934222 129.934222 0 0 0 129.877334 129.934222h424.504888a129.934222 129.934222 0 0 0 129.877334-129.934222V228.750222h105.813333a35.441778 35.441778 0 0 0 35.441778-35.498666 34.816 34.816 0 0 0-35.498667-34.702223zM512 806.570667a35.441778 35.441778 0 0 0 35.498667-35.498667V393.443556a35.441778 35.441778 0 1 0-70.997334 0v377.628444c0 19.626667 15.872 35.498667 35.498667 35.498667z m-165.432889 0a35.441778 35.441778 0 0 0 35.498667-35.498667V393.443556a35.441778 35.441778 0 1 0-70.997334 0v377.628444a36.408889 36.408889 0 0 0 35.498667 35.498667z m330.865778 0a35.441778 35.441778 0 0 0 35.498667-35.498667V393.443556a35.441778 35.441778 0 1 0-70.997334 0v377.628444c0 19.626667 15.815111 35.498667 35.498667 35.498667z" fill="var(--el-color-danger)" p-id="16645"></path></svg>
     ${t('safeProtectionModule.confirmRemove',{ type: titleLabel.value[type] })}</div>`,
    t('safeProtectionModule.tip'),
    {
      confirmButtonText: t('common.delete'),
      cancelButtonText: t('common.cancel'),
      dangerouslyUseHTMLString: true,
      confirmButtonClass:'cm-btn-del',
    },
  )
    .then(async () => {
      const ids = isMultiple ? idsByType[type] : idsByType[type]
      idsByType[type] = ids
      const ok = await handleSubmit(true, () => { }, true)
      if (ok) {
        ElMessage({
          type: 'success',
          message: t('safeProtectionModule.removeSuccess'),
        })
      }
    })
}
const getDataByType = async () => {
  loading.value = true
  const result = await getByTypeApi({ type: PolicySettingType.file_whitelist }).finally(() => { loading.value = false })
  strategyObj.value = result.data || {}
  const strategyStringToObj = strategyObj.value.strategy ? JSON.parse(strategyObj.value.strategy) : {}
  if (!result.data?.strategy) return
  for (let key in file_key) {
    if (Array.isArray(strategyStringToObj.whitelist?.[file_key[key]])) {
      strategyStringToObj.whitelist[file_key[key]] = strategyStringToObj.whitelist[file_key[key]].map((item, index) => ({ index, ...item }))
    } else {
      strategyStringToObj.whitelist[file_key[key]] = []
    }
    listByType.value[file_key[key]].length = 0
    for (let item of strategyStringToObj.whitelist[file_key[key]]) {
      if (item.status === 2) continue
      if (item.value != null && item.value !== '') {
        listByType.value[file_key[key]].push({
          index: String(item.index),
          comment: item.comment,
          value: item.value,
          update_by: item.update_by || '',
          update_time: item.update_time || '',
        })
      }
    }
  }

  console.log('result :>> ', listByType.value);
}
const subType = ref()
const headers = ref({})
const data = ref({})
const method = ref('')
const exact_url = ref('')

const handleSubmit = async (valid: boolean, done: (ok: boolean, message?: string, normalClick?: boolean) => void, type: boolean): Promise<boolean> => {
  if (!valid) return false
  const strategy = strategyObj.value?.strategy ? JSON.parse(strategyObj.value?.strategy) : { whitelist: {} }
  for (let item in file_key) {
    strategy.whitelist[file_key[item]] = [...(strategy.whitelist?.[file_key[item]] || [])]
  }
  console.log('strategy :>> ', strategy);
  subType.value = type ? 2 : 1
  if (!type) {
    const wlArr = strategy.whitelist[file_key[activeName.value]]
    ;[...form.value.addFile].reverse().forEach((v) => {
      wlArr.unshift({
        value: v,
        comment: form.value.remark,
        status: 1,
      })
    })
    const currentValuesLength = countWhitelistEntries(strategy.whitelist[file_key[activeName.value]])
    if (currentValuesLength > 1000) {
      ElMessage({
        type: 'error',
        message: t('safeProtectionModule.addFailLimit', { type: titleLabel.value[activeName.value] }),
      })
      handleResetForm()
      done(false)
      return false
    }
  }
  if (type) {
    const wlKey = file_key[activeName.value]
    const wl = strategy.whitelist[wlKey]
    const rawIds = [...idsByType[activeName.value]]
    new Set(rawIds.map((id) => Number(String(id).split('_')[0]))).forEach((i) => {
      if (wl[i]) wl[i].status = 2
    })
  }
  console.log('handleCustomOperateType(activeName.value,subType.value) :>> ', handleCustomOperateType(activeName.value, subType.value));
  console.log('subType.value :>> ', subType.value);
  const formData = {
    name: '查杀黑白名单',
    group_ids: [-1],
    bind_mode: 0,
    device_ids: [] as string[],
    id: strategyObj.value.id,
    type: PolicySettingType.file_whitelist,
    strategy_type: PolicyType.file_whitelist_type,
    strategy: JSON.stringify(strategy),
    custom_operate_type: handleCustomOperateType(activeName.value, subType.value)
  }
  const result: any = await saveOrUpdateApi(formData).catch(err => console.log('err', err))
  const ok = result?.resp_common?.msg === 'ok'
  done(ok)
  ok && handleResetForm()
  queryForms[activeName.value].file_name = ''
  if (ok) {
    await getDataByType()
    await nextTick()
    clearAllWhitelistTableSelection()
  }
  console.log('formData :>> ', formData);
  return !!ok
}
const handleCloseTag = (index, prop) => {
  form.value[prop].splice(index, 1,)
  formRef?.value.ruleFormRef?.validateField?.(prop)
}
const handleResetForm = async () => {
  form.value = { ...resetForm }
  form.value.remark = ''
  subType.value = null
  form.value.calc_md5 = ''
  form.value.addFile.length = 0
  clearInterval(interval.value);
  formRef.value?.ruleFormRef?.clearValidate()
  visible.value = false
  await nextTick()
  md5Loading.value = false
  clearFile()
  uploadedFiles.value = []
  uploadProgress.value = { current: 0, total: 0 }
}
const handleAddTags = (prop) => {
  form.value[prop].push(
    ...multiWords.value
      .split(/[,，、;；]/)
      .filter((item) => !!item.trim())
      .map((item) => item.trimEnd().trimStart())
  )
  multiWords.value = ''
  form.value[prop] = [...new Set(form.value[prop])]
  formRef?.value.ruleFormRef?.validateField?.(prop)
}
watch(() => activeName.value, () => {
  handleResetForm()
})
onMounted(async () => {
  getDataByType()
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_tooltip, {
      placement: "left-start",
      trigger: "hover",
      effect: "light"
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('safeProtectionModule.fileWhitelistDesc')), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.fileWhitelistIntro')), 1)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(StatisticsCards, { items: whitelistStatisticsItems.value }, null, 8, ["items"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(WhitelistSection, {
        ref_key: "sectionRefSigns",
        ref: sectionRefSigns,
        type: _unref(WhiteListType).FILE_CHARACTERISTICS,
        title: titleLabel.value[_unref(WhiteListType).FILE_CHARACTERISTICS],
        table_title: tableTitleLabel.value[_unref(WhiteListType).FILE_CHARACTERISTICS],
        count: listByType.value[_unref(file_key)[_unref(WhiteListType).FILE_CHARACTERISTICS]]?.length || 0,
        data: listByType.value[_unref(file_key)[_unref(WhiteListType).FILE_CHARACTERISTICS]],
        "query-form": queryForms[_unref(WhiteListType).FILE_CHARACTERISTICS],
        "onUpdate:queryForm": _cache[0] || (_cache[0] = (val) => queryForms[_unref(WhiteListType).FILE_CHARACTERISTICS] = val),
        onAdd: _cache[1] || (_cache[1] = () => openAddDialog(_unref(WhiteListType).FILE_CHARACTERISTICS)),
        onBatchRemove: _cache[2] || (_cache[2] = () => handleBatchRemove(_unref(WhiteListType).FILE_CHARACTERISTICS)),
        onRemove: _cache[3] || (_cache[3] = (row) => handleRemove(_unref(WhiteListType).FILE_CHARACTERISTICS, row)),
        onChangeSelected: _cache[4] || (_cache[4] = (ids) => handleChangeSelected(_unref(WhiteListType).FILE_CHARACTERISTICS, ids))
      }, null, 8, ["type", "title", "table_title", "count", "data", "query-form"]),
      _createVNode(WhitelistSection, {
        ref_key: "sectionRefFiles",
        ref: sectionRefFiles,
        type: _unref(WhiteListType).FILE_PATH,
        title: titleLabel.value[_unref(WhiteListType).FILE_PATH],
        table_title: tableTitleLabel.value[_unref(WhiteListType).FILE_PATH],
        count: listByType.value[_unref(file_key)[_unref(WhiteListType).FILE_PATH]]?.length || 0,
        data: listByType.value[_unref(file_key)[_unref(WhiteListType).FILE_PATH]],
        "query-form": queryForms[_unref(WhiteListType).FILE_PATH],
        "onUpdate:queryForm": _cache[5] || (_cache[5] = (val) => queryForms[_unref(WhiteListType).FILE_PATH] = val),
        onAdd: _cache[6] || (_cache[6] = () => openAddDialog(_unref(WhiteListType).FILE_PATH)),
        onBatchRemove: _cache[7] || (_cache[7] = () => handleBatchRemove(_unref(WhiteListType).FILE_PATH)),
        onRemove: _cache[8] || (_cache[8] = (row) => handleRemove(_unref(WhiteListType).FILE_PATH, row)),
        onChangeSelected: _cache[9] || (_cache[9] = (ids) => handleChangeSelected(_unref(WhiteListType).FILE_PATH, ids))
      }, null, 8, ["type", "title", "table_title", "count", "data", "query-form"]),
      _createVNode(WhitelistSection, {
        ref_key: "sectionRefDirs",
        ref: sectionRefDirs,
        type: _unref(WhiteListType).FILE_FOLDER,
        title: titleLabel.value[_unref(WhiteListType).FILE_FOLDER],
        table_title: tableTitleLabel.value[_unref(WhiteListType).FILE_FOLDER],
        count: listByType.value[_unref(file_key)[_unref(WhiteListType).FILE_FOLDER]]?.length || 0,
        data: listByType.value[_unref(file_key)[_unref(WhiteListType).FILE_FOLDER]],
        "query-form": queryForms[_unref(WhiteListType).FILE_FOLDER],
        "onUpdate:queryForm": _cache[10] || (_cache[10] = (val) => queryForms[_unref(WhiteListType).FILE_FOLDER] = val),
        onAdd: _cache[11] || (_cache[11] = () => openAddDialog(_unref(WhiteListType).FILE_FOLDER)),
        onBatchRemove: _cache[12] || (_cache[12] = () => handleBatchRemove(_unref(WhiteListType).FILE_FOLDER)),
        onRemove: _cache[13] || (_cache[13] = (row) => handleRemove(_unref(WhiteListType).FILE_FOLDER, row)),
        onChangeSelected: _cache[14] || (_cache[14] = (ids) => handleChangeSelected(_unref(WhiteListType).FILE_FOLDER, ids))
      }, null, 8, ["type", "title", "table_title", "count", "data", "query-form"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((visible).value = $event)),
      title: dialogTitle.value[activeName.value] || _ctx.$t('safeProtectionModule.fileWhitelistDialogTitle'),
      width: "680px",
      onClose: _cache[20] || (_cache[20] = () => handleResetForm())
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_card, {
          shadow: "none",
          bodyStyle: "padding: 15px;",
          class: "cm-ui-mb15",
          style: {"border-color":"var(--el-color-primary)","font-size":"14px","background-color":"var(--el-color-primary-light-9)"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(labelTipI18n.value[activeName.value], (tip, index) => {
                  return (_openBlock(), _createElementBlock("p", { key: tip }, _toDisplayString(tip), 1))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(CmForm, {
          formSize: _unref(formSize),
          rowOpt: { style: 'justify-content: flex-end', },
          ref_key: "formRef",
          ref: formRef,
          actionColOpt: { style: 'display:flex;justify-content:flex-end' },
          "form-opt": { 'label-width': 'auto' },
          disabled: queryFormDisabled.value,
          "onUpdate:disabled": _cache[16] || (_cache[16] = ($event: any) => ((queryFormDisabled).value = $event)),
          modelValue: form.value,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form).value = $event)),
          formColumns: formColumns.value,
          onReset: _cache[18] || (_cache[18] = ($event: any) => (handleResetForm())),
          onSubmit: handleSubmit
        }, {
          addFile: _withCtx((slotProps) => [
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value[(slotProps as any).prop], (tag, index) => {
                    return (_openBlock(), _createBlock(_component_el_tag, {
                      key: tag,
                      style: {"word-break":"break-all","max-width":"auto"},
                      title: tag,
                      closable: true,
                      type: !_unref(file_pattern)[activeName.value].test(tag) ? 'danger' : 'primary',
                      round: true,
                      size: "small",
                      onClose: ($event: any) => (handleCloseTag(index, (slotProps as any).prop))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(tag.slice(0, 32) + (tag.length > 32 ? '...' : '')), 1)
                      ]),
                      _: 2
                    }, 1032, ["title", "type", "onClose"]))
                  }), 128))
                ])
              ], 512), [
                [_vShow, form.value[(slotProps as any).prop].length]
              ]),
              _createVNode(_component_el_input, _mergeProps({
                class: "tags",
                modelValue: multiWords.value,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((multiWords).value = $event)),
                modelModifiers: { trim: true },
                onKeyup: _withKeys(($event: any) => (handleAddTags((slotProps as any).prop)), ["enter"]),
                size: "small",
                onBlur: ($event: any) => (handleAddTags((slotProps as any).prop))
              }, (slotProps as any).formItem.inputOpt, {
                type: (slotProps as any).formItem.inputType,
                placeholder: (slotProps as any).formItem.placeholder
              }), null, 16, ["modelValue", "onKeyup", "onBlur", "type", "placeholder"])
            ])
          ]),
          calc_md5: _withCtx((slotProps) => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  loading: md5Loading.value,
                  onClick: handleSelectFiles
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(md5Loading.value ? _ctx.$t('safeProtectionModule.calculatingMd5Progress', { current: uploadProgress.value.current, total: uploadProgress.value.total }) : _ctx.$t('safeProtectionModule.selectFile')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createElementVNode("input", {
                  ref_key: "fileInputRef",
                  ref: fileInputRef,
                  type: "file",
                  multiple: "",
                  accept: "*/*",
                  style: {"display":"none"},
                  onChange: handleFilesChange
                }, null, 544)
              ]),
              (uploadedFiles.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploadedFiles.value, (file, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "uploaded-file-item"
                      }, [
                        _createVNode(_component_el_tag, {
                          title: file.name,
                          type: file.status === 'success' ? 'success' : file.status === 'error' ? 'danger' : 'info',
                          size: "small",
                          closable: "",
                          onClose: ($event: any) => (removeUploadedFile(index))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_14, _toDisplayString(file.name.length > 30 ? file.name.slice(0, 30) + '...' : file.name), 1),
                            (file.status === 'uploading')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t('safeProtectionModule.uploading')), 1))
                              : (file.status === 'calculating')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t('safeProtectionModule.calculatingMd5')), 1))
                                : (file.status === 'error')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t('safeProtectionModule.failed')), 1))
                                  : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["title", "type", "onClose"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["formSize", "disabled", "modelValue", "formColumns"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})